import {
  Avatar,
  Button,
  Drawer,
  Image,
  Skeleton,
  Tooltip
} from "antd";
import Container from "components/container";
import { FC, useCallback, useEffect, useState } from "react";

import * as AUTH_SERVICES from "api/services/auth/auth.services";
import { findLevelsById } from "api/services/levels/levels.services";
import EnglishIcon from "assets/images/students/englishIcon.svg";
import FrenchIcon from "assets/images/students/frenchIcon.svg";
import StartIcon from "assets/images/students/teacherStart.svg";
import { FLAGS, StatusCode, useBackForwardHandler } from "common/enums";
import CertificationBadge from "components/certificationBadge";
import * as appRoutes from "config/routes.config";
import React from "react";
import { useTranslation } from "react-i18next";
import Latex from "react-latex-next";
import "react-phone-input-2/lib/material.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TeacherCalendarForStudent from "screens/student/components/calendarTeacher";
import IconCourse from "screens/student/searchTeacher/components/iconCourse";
import DrawerSearchInstaProf from "screens/student/searchTeacher/drawerSearchInstaProf";
import { setChatReceiverId, setSelectUserChat, toggleAppChat } from "store/AppChat/appChat";
import { closeProfileDetailsDrawer, setIdTeacher, setUserConnect } from "store/auth/authSlice";
import { useFindRoomMutation } from "store/services/chat";
import { handleClearTopic, handleClearTopicStrings } from "utils/formats";
import ArrowBack from "../../assets/images/app/arrow_back.png";
import InstaIcon from "../../assets/images/app/insta_icon.svg";
import MessageIcon from "../../assets/images/app/message_icon.svg";
import PlanningButtonIcon from "../../assets/images/app/planning_icon.svg";
import BadgeInsta from "../../assets/images/students/badgeInstaProf.svg";
import cardImage from '../../assets/images/teacher/card.svg';
import TEACHER from "../../assets/images/teacher/teacher.svg";
import st from "../../screens/student/searchTeacher/components/assets/cardTeacher.module.css";
import s from "./assets/style.module.css";

//!STYLES

export const ProfileDetailsDrawer: FC = () => {
  //!HOOKS
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isStudent, setIsSudent] = useState<boolean>(false);
  const [teacherData, setTeacherData] = useState<any>();
  const [studentData, setStudentData] = useState<any>();
  const [userLevel, setUserLevel] = useState<any>();
  const navigate = useNavigate();

  const [open, setOpen] = useState<boolean>(false);
  const [isBtnInstaProf, setIsBtnInstaProf] = useState<boolean>(false);
  const [openDrawerInstaProf, setOpenDrawerInstaProf] = useState<boolean>(false);
  const [findRoom, { isSuccess: isSuccessRooms }] = useFindRoomMutation();

  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [closeInstaprof, setCloseInstaprof] = useState<boolean>(false);

  const showDrawerSearchInstaProf = () => {
    if (isLoggedIn) {
      setOpenDrawerInstaProf(!openDrawerInstaProf);
    } else {
      dispatch(setUserConnect(true));
    }
  };

  const {
    profileDetailsDrawerOpen,
    profileDetailsID,
    profileDetailsType,
    user,
    isLoggedIn,
  } = useSelector((state) => state.auth);

  //STATES
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const handleProfileClick = () => {
    if (isLoggedIn) {
      dispatch(closeProfileDetailsDrawer());
      dispatch(setIdTeacher(teacherData?.teacher?._id));
      const profileUrl = `${appRoutes.PROFILETEACHER}/${teacherData?.teacher?._id}/${teacherData?.teacher?.firstname ? teacherData?.teacher?.firstname : "nom"}.${teacherData?.teacher?.lastname ? teacherData?.teacher?.lastname : "complet"}`;
      window.open(profileUrl, "_blank");
    } else {
      dispatch(setUserConnect(true));
    }
  }

  //!FUNCTIONS
  const closeDrawer = () => {
    dispatch(closeProfileDetailsDrawer());
  };

  const handleDisplayTeacher = (idTeacher: string) => {
    const finalData = {
      actor1: user?._id,
      actor2: idTeacher,
      flag: FLAGS.SINGLE_FLAG,
      type: "",
      instaprof: "",
    };

    findRoom(finalData);
    dispatch(setChatReceiverId(idTeacher));
  };

  const getUserData = async (userId: string) => {
    try {
      setIsLoading(true);
      const response = await AUTH_SERVICES.getUserByUid(userId);
      if (response?.data) {
        if (response?.data?.roles[0] === "student") {
          setIsSudent(true);
          setStudentData(response?.data);
          getLevelById(response?.data?.levelId);
        }
        else {
          setIsSudent(false);
          getTeacherData(response?.data?._id);
        }
      } else {
        throw new Error("L'utilisateur n'existe pas");
      }
    } catch (error) { }
  }

  const getTeacherData = async (teacherId: string) => {
    try {
      const response = await AUTH_SERVICES.getTeacherData(user?._id, teacherId);
      setTeacherData(response?.data);
    } catch (error: any) { }
    finally {
      setIsLoading(false);
    }
  };

  const getLevelById = useCallback(
    async (idLevel: any) => {
      try {
        if (idLevel) {
          const response = await findLevelsById(idLevel);
          if (response.statusCode === StatusCode.OK) {
            setUserLevel(response?.data['title']);
            setIsLoading(false);
          }
        }
      } catch (error) { }
    },
    [userLevel]
  );

  const pathTeacherObj = {
    teacher: teacherData?.teacher,
  };

  const setOpenTeacherCalendar = () => {
    localStorage.setItem("level", user?.levelId);
    setOpen(true);
  };

  // Prevent router nav
  useBackForwardHandler(isSearching, () => {
    console.log("User attempted to navigate while searching");
  });

  // Prevent reload/close
  useEffect(() => {
    if (!openDrawerInstaProf && !isSearching) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      setCloseInstaprof(true);
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [openDrawerInstaProf, isSearching]);

  // !USE_EFFECT
  useEffect(() => {
    if (profileDetailsID) {
      getUserData(profileDetailsID);
    }
  }, [profileDetailsID, profileDetailsType]);

  useEffect(() => {
    if (isSuccessRooms) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccessRooms]);

  return (
    <div>
      <Container>
        <Drawer
          headerStyle={{ height: "70px", width: "100%", position: "relative", backgroundColor: "#8AB0B1" }}
          title={<div style={{ display: "flex", flexDirection: "row", background: "#8AB0B1", color: "#FFF", fontSize: isMobile ? "0.8em" : "18px", fontWeight: "600", fontFamily: "Poppins" }}><Image src={ArrowBack} width={isMobile ? 12 : 25} preview={false} onClick={closeDrawer} style={{ cursor: "pointer" }} />  <span style={{ marginLeft: "10px" }}>Détail du profil</span></div>}
          closable={false}
          width={isMobile ? "100%" : "35%"}
          onClose={closeDrawer}
          visible={profileDetailsDrawerOpen}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

            {isStudent && <div style={{ height: isMobile ? "300px" : "520px", width: isMobile ? "80%" : "450px", background: `url(${cardImage})`, backgroundSize: "cover", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", paddingTop: isMobile ? "15px" : "35px", paddingLeft: isMobile ? "30px" : "70px", paddingRight: "20px" }}>
              {isLoading ? <Skeleton></Skeleton> : <Avatar
                src={studentData?.profile}
                size={isMobile ? 50 : 100}
                style={{
                  background: "#fff",
                  border: "1px solid #707070"
                }}
              />}

              {/* Name and Rate */}
              {isLoading ? <Skeleton></Skeleton> : <div className={s.details}>
                <div className={s.name}>
                  {studentData?.firstname?.split(" ")[0] || "-"}{" "}
                  {studentData?.lastname?.split(" ")[0] || "-"}
                </div>

                <div className={s.subjects} style={{ margin: "0px auto" }}>
                  <div style={{ fontWeight: "700" }} className={`${handleClearTopic(teacherData?.topic)?.length <= 5 ? s.singleCourse : s.cardDisplay}`}>
                    <div style={{ background: "#D5D5D5", width: "auto", paddingLeft: "15px", paddingRight: "15px", paddingTop: "5px", paddingBottom: "5px", margin: "0px auto", borderRadius: "12px", fontSize: isMobile ? "0.8em" : "12px" }}>{userLevel}</div>
                  </div>
                  <br />
                </div>
              </div>}

              {/* Buttons */}
              {isLoading ? <Skeleton></Skeleton> : <div className={s.rowButtons}>
                {user?._id && (
                  <Button
                    onClick={() => handleDisplayTeacher(studentData?._id)}
                    className={s.newMessageButton}
                  >
                    <img src={MessageIcon} height={14} style={{ marginRight: "5px" }} />
                    Envoyer un message
                  </Button>
                )}
              </div>}
            </div>}

            {!isStudent && <React.Fragment>
              {isLoading ? <>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
                <Skeleton></Skeleton>
              </> :
                <div style={{ height: isMobile ? "340px" : "520px", width: isMobile ? "80%" : "450px", background: `url(${cardImage})`, backgroundSize: "cover", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", paddingTop: isMobile ? "15px" : "35px", paddingLeft: isMobile ? "30px" : "70px", paddingRight: "20px" }}>
                  <div className={st.avatarNameBoxDrawer} onClick={handleProfileClick}>
                    {teacherData?.teacher?.instaProf ? <img src={BadgeInsta} height={isMobile ? 20 : 40} style={{ position: "relative", right: isMobile ? "-30px" : "-40px", top: isMobile ? "20px" : "-40px", zIndex: "2" }}></img> : <div style={{ position: "relative", right: "-40px", top: "40px", zIndex: "2", height: "40px", width: "40px" }}></div>}
                    <div className={st.avatarBox}><img src={teacherData?.teacher?.profile || TEACHER} height={isMobile ? 40 : 70} style={{ borderRadius: "50%" }} /></div>
                    <div className={st.nameRateBox}>
                      <Tooltip
                        title={
                          <span style={{ textTransform: "capitalize" }}>
                            {teacherData?.teacher?.firstname + " " + teacherData?.teacher?.lastname ||
                              "-"}
                          </span>
                        }
                      >
                        <div className={st.nameBox}>
                          {teacherData?.teacher?.firstname?.split(" ")[0] || "-"}{" "}
                          {teacherData?.teacher?.lastname?.split(" ")[0] || "-"}
                          {teacherData?.teacher?.certified && <CertificationBadge />}
                        </div>
                      </Tooltip>

                      <span style={{ textTransform: "uppercase", lineHeight: isMobile ? "10px" : "14px" }}>
                        {teacherData?.teacher?.points > 0 &&
                          teacherData?.teacher?.points <= 1000 &&
                          "C'est mon ami"}
                        {teacherData?.teacher?.points > 1000 &&
                          teacherData?.teacher?.points <= 5000 &&
                          "C'est mon grand ami"}
                        {teacherData?.teacher?.points > 5000 &&
                          teacherData?.teacher?.points <= 10000 &&
                          "C'est mon vieil ami"}
                        {teacherData?.teacher?.points > 10000 && "Tu es mon meilleur ami"}
                      </span>

                      <div className={st.rate} style={{ lineHeight: isMobile ? "15px" : "20px" }}>
                        <span className={st.rateNumber}>
                          {teacherData?.teacher?.rate && teacherData?.teacher?.rate !== 0 && Number(teacherData?.teacher?.rate).toFixed(2)}
                          {teacherData?.teacher?.rate && teacherData?.teacher?.rate !== 0 && <img src={StartIcon} style={{ position: "relative", top: "-2px", marginLeft: "5px", marginRight: "5px" }} />}
                          {teacherData?.teacher?.rateNum && teacherData?.teacher?.rateNum !== 0 && `(${teacherData?.teacher?.rateNum || 0} avis)`}
                        </span>
                      </div>

                      <div style={{ color: "#707070", lineHeight: "10px" }}>
                        <>
                          <span>
                            Je parle
                          </span>{" "}
                          {teacherData?.language?.includes("en") && (
                            <>
                              <img src={EnglishIcon} alt="" />{" "}
                            </>
                          )}
                          {teacherData?.language?.includes("fr") && (
                            <img src={FrenchIcon} alt="" />
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                  <div className={st.descriptionDrawer}>
                    <Latex>
                      {teacherData?.teacher?.career
                        ? teacherData?.teacher?.career?.replace(/<\/?strong>/g, '').substring(0, 300)?.concat("...")
                        : "Aucune description disponible"}
                    </Latex>
                  </div>
                  <div className={st.matiersDrawer}>
                    {handleClearTopicStrings(teacherData?.teacher?.matieres)?.map((item: string) =>
                      item ? (
                        <div className={st.courseDrawer} key={item}>
                          <IconCourse course={item} />
                          <span>
                            {item.includes("-")
                              ? item.split("-")[0]
                              : item === "Anglais"
                                ? "Anglais"
                                : item === "Mathématiques"
                                  ? "Maths"
                                  : item.substring(0, 4)}
                          </span>
                        </div>
                      ) : null
                    )}
                  </div>
                  <div className={st.levelGroupDrawer}>
                    {teacherData?.teacher?.groupLevels?.length > 0 ? <div style={{ display: "grid", gridTemplateColumns: "repeat(3, auto)", gap: "5px", justifyContent: "center", margin: "0 auto" }}>
                      {teacherData?.teacher?.groupLevels?.map((level: any, index: number) => {
                        return (
                          level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                            <div className="teacherLevelBox" style={{ marginRight: "5px" }} key={index}>{level?.levelGroup}</div>
                          </div>
                        );
                      })}
                    </div> : <span>Non renseigné</span>}
                  </div>
                  {<div className={st.tarifDrawer}>
                    <span>Mes cours à partir de</span>{" "}
                    {teacherData?.minPrice} €/séance
                  </div>}
                  <div className={st.rowButtonsDrawer}>
                    <Button className={st.newPlanningButton} onClick={setOpenTeacherCalendar}>
                      <img
                        src={PlanningButtonIcon}
                        alt=""
                        style={{
                          position: "relative",
                          top: "-1px",
                          marginRight: "5px",
                        }}
                      />
                      Mon Planning
                    </Button>

                    <Button
                      onClick={() => {
                        setIsBtnInstaProf(true);
                        showDrawerSearchInstaProf();
                      }}
                      className={st.newInstaButton}
                    >
                      <img
                        src={InstaIcon}
                        alt=""
                        style={{ height: "20px", marginRight: "5px" }}
                      />
                      InstaProf
                    </Button>

                    {user?._id && (
                      <Button
                        onClick={() => handleDisplayTeacher(teacherData?.teacher?._id)}
                        className={st.newMessageButton}
                      >
                        <img src={MessageIcon} height={14} />
                      </Button>
                    )}
                  </div>
                </div>}
            </React.Fragment >}

          </div>
          {!isStudent && !isLoading && <Button className={s.newPlanningButton} onClick={handleProfileClick} style={{ margin: "30px auto" }}>
            Voir profil prof
          </Button>}
        </Drawer>

        <TeacherCalendarForStudent
          setOpen={setOpen}
          open={open}
          currentTeacher={teacherData}
        />

        <DrawerSearchInstaProf
          openDrawerInstaProf={openDrawerInstaProf}
          showDrawerSearchInstaProf={showDrawerSearchInstaProf}
          isBtnInstaProf={isBtnInstaProf}
          setIsBtnInstaProf={setIsBtnInstaProf}
          dataOfTeacher={teacherData}
          setIsSearching={setIsSearching}
          closeInstaprof={closeInstaprof}
        />
      </Container>
    </div>
  );
};
